<!-- Compra para invitdaos -->
<ng-container *ngIf="guestPurchase">
    <ng-container *ngIf="fullForm">
        <form class="form-horizontal" [formGroup]="guestForm" #formDir="ngForm">
            <div class="row">
                <!-- Name -->
                <div class="col-6 form-group" [ngClass]="{'has-danger': invalidName}">
                    <label class="font-l1">Nombre</label>
                    <input class="form-control" type="text" placeholder="Nombre" formControlName="name">
                    <div class="form-control-feedback" *ngIf="invalidName">
                        <small *ngIf="name.errors?.required">
                            El nombre es requerido
                        </small>
                    </div>
                </div>
                <!-- Surname -->
                <div class="col-6 form-group" [ngClass]="{'has-danger': invalidSurname}">
                    <label class="font-l1">Apellido</label>
                    <input class="form-control" type="text" placeholder="Apellido" formControlName="surname">
                    <div class="form-control-feedback" *ngIf="invalidSurname">
                        <small *ngIf="surname.errors?.required">
                            El apellido es requerido
                        </small>
                    </div>
                </div>
            </div>
            <!-- Email -->
            <div class="row">
                <div class="col-12">
                    <div class="form-group" [ngClass]="{'has-danger': invalidEmail}">
                        <label class="font-l1">Email</label>
                        <input class="form-control" type="email" placeholder="Email" formControlName="email"
                            (blur)="findEmail()">
                        <div class="form-control-feedback" *ngIf="invalidEmail">
                            <small *ngIf="email.errors?.email">
                                El email debe ser válido
                            </small>
                            <small *ngIf="email.errors?.required">
                                El email es requerido
                            </small>
                        </div>
                        <small class="text-danger" *ngIf="!notRegisteredEmail">
                            El email esta asociado a otro número de teléfono
                        </small>
                    </div>
                </div>
            </div>
            <!-- Cedula -->
            <div *ngIf="showIdNumber" class="row">
                <div class="col-12">
                    <div class="form-group" [ngClass]="{'has-danger': invalidIdNumber}">
                        <label class="font-l1">Cédula</label>
                        <input class="form-control" type="text" placeholder="Cédula" formControlName="idNumber">
                        <div class="form-control-feedback" *ngIf="invalidIdNumber"> 
                            <small *ngIf="idNumber.errors?.required">
                                La cédula es requerida
                            </small>
                            <small *ngIf="(idNumber.errors?.minlength)">
                                La identificación debe tener mínimo <b>8</b> dígitos para la cédula.
                            </small>
                        </div> 
                    </div>
                </div>
            </div>
        </form>
    </ng-container>

    <div class="payment-method" *ngIf="total > 0 || checkoutType == 'gf' || checkoutType == 'cp'">
        <div class="font-b1 m-b-10">Información para el Pago</div>

        <!-- Formulario de tarjeta compartido: muestra los campos de ONVO o los de
             Stripe según la pasarela del país -->
        <app-card-form [country]="country" [showSaveCard]="true"
            (cardChange)="onGuestCardChange($event)"></app-card-form>
    </div>
</ng-container>
<!-- Compra normal -->
<ng-container *ngIf="!guestPurchase">
    <div class="font-c1 m-b-10">Seleccioná tu tarjeta para realizar el Pago</div>

    <div *ngIf="paymentMethods?.length">
        <!-- Tarjeta -->
        <div *ngIf="paymentMethods?.length == 1" >
            <div class="card-box cursor-pointer border-primary">
                <!-- LOGO -->
                <div class="text-left">
                    <img class="m-5-5 p-r-10" src="{{currentMethod.logoURL}}" width="36">

                    <span class="font-bold font-12">
                        {{currentMethod?.name ? currentMethod?.name : '**** **** ****' }} {{currentMethod.masked}}
                    </span>
                    <!-- Delete -->
                    <span class="font-bold font-10 cursor-pointer" (click)="onDeleteMethod(currentMethod)">
                        <i class="mdi mdi-delete mdi-24px text-danger"></i>
                    </span>
                </div>
                <!-- Check -->
                <div style="position: absolute; top: 10px; right: 10px; padding: 2px 2px 0 2px;">
                    <i class="mdi mdi-check-underline mdi-24px text-primary"></i>
                </div>
            </div>
        </div>

        <!-- Tarjetas -->
        <div *ngIf="paymentMethods?.length > 1">
            <div *ngFor="let sourceItem of paymentMethods; let last = last">
                <div [ngClass]="{'p-b-20': !last}" >
                    <div class="card-box cursor-pointer" (click)="onSelectMethod(sourceItem)"
                        [ngClass]="{'border-primary': (sourceItem == currentMethod)}">
                        <!-- LOGO -->
                        <div class="text-left">
                            <img class="m-5-5" src="{{sourceItem.logoURL}}" width="36">

                            <span class="font-bold font-10 m-r-10">
                                {{sourceItem?.name ? sourceItem?.name : '**** **** ****' }} {{sourceItem.masked}}
                            </span>
                            <!-- Delete -->
                            <span class="font-bold font-10 cursor-pointer" (click)="onDeleteMethod(sourceItem)">
                                <i class="mdi mdi-delete mdi-24px text-danger"></i>
                            </span>
                        </div>
                        <!-- Check -->
                        <div *ngIf="sourceItem == currentMethod"
                            style="position: absolute; top: 10px; right: 10px; padding: 2px 2px 0 2px;">
                            <i class="mdi mdi-check-underline mdi-24px text-primary"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!paymentMethods?.length" class="m-l-15 text-muted font-c1">
        No tenés métodos de pago registrados.
    </div>

    <!-- Agregar tarjeta -->
    <div class="p-b-10 comment-row" (click)="onCreateCard(addPaymentMethodModal)">
        <div class="d-flex content-label-card text-center">
            <div class="m-l-10 m-t-8">
                <i class="mdi mdi-plus-circle-outline mdi-36px m-r-8"></i>
            </div>
            <div class="fond-card" style="margin-top: 16px;">
                Agregar nueva tarjeta
            </div>
        </div>
    </div>
</ng-container>



<!-- Agregar nueva tarjeta -->
<ng-template #addPaymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="m-b-20 border-bottom cursor-pointer">
            <div class="text-center">
                <i class="mdi mdi-credit-card-plus mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Agregar nueva tarjeta
            </div>
        </div>

        <!-- Formulario de tarjeta compartido: ONVO o Stripe según el país -->
        <div class="m-b-20 p-20">
            <app-card-form [country]="country" (cardChange)="onCardChange($event)"></app-card-form>

            <div>
                <img src="assets/images/masterVisaStripe.png" height="28">
            </div>
        </div>

        <div class="d-flex-center">
            <button [disabled]="readonly || !newCard" (click)="onSaveCard(modal)"
                class="btn btn-primary btn-sm m-2">Agregar</button>
        </div>
    </div>
</ng-template>